import { PersistentStore, Store } from './main';
import { IProject } from '@/models/project.model';
import { ITopic, IVoteStatus } from '@/models/topic.model';
import { RepositoryFactory } from '@/api/repositoryFactory';
import { domainStore } from '@/store/domain-store';
const ProjectRepository = RepositoryFactory.get('project');
const TopicRepository = RepositoryFactory.get('topic');

interface ProjectStoreModel extends Object {
  projectid: number | null;
  project: IProject | null;
  topics: ITopic[];
  topicAttributes: any;
  currentVoteStatus: IVoteStatus | null;
}

class ProjectStore extends PersistentStore<ProjectStoreModel> {
  protected data(): ProjectStoreModel {
    return {
      projectid: null,
      project: null,
      topics: [],
      topicAttributes: [],
      currentVoteStatus: null,
    };
  }
  private setProject(project: IProject) {
    this.state.project = project;

    let thought_term = '';
    // ignore terms "idee" from old project.configs and module "idea" from new module differentiation
    if (project.config?.thought_term && project.config?.thought_term !== 'idee') {
      thought_term = project.config?.thought_term;
    } else if (project.module && project.module !== 'idea') {
      thought_term = project.module;
    }
    // update language here depending on project settings or module:
    domainStore.updateProjectThoughtTerm(thought_term);
  }
  setProjectId(projectid: number, fetchTopics = true) {
    return new Promise((resolve, reject) => {
      this.state.projectid = projectid;
      this.fetchProject()
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
      if (fetchTopics) {
        this.fetchTopics();
      }
    });
  }

  private fetchProject() {
    return new Promise((resolve, reject) => {
      if (this.state.project && this.state.projectid == this.state.project.id) {
        resolve(this.state.project);
      }
      // console.log("fetching project");

      // if project-id is set, fetch project
      if (this.state.projectid) {
        ProjectRepository.getItem(this.state.projectid, 'config')
          .then((project: any) => {
            if (project) {
              this.setProject(project);
              resolve(project);
            } else {
              reject(null);
              console.log('error');
            }
          })
          .catch((error: any) => {
            console.log(error);
            reject(error);
          });
      }
    });
  }

  // topics
  private setTopics(topics: ITopic[]) {
    this.state.topics = topics;
  }
  private addToTopics(topic: ITopic) {
    let foundTopic = false;
    // exchange in local topics
    this.state.topics = this.state.topics.map(function (t) {
      if (t.id === topic.id) {
        foundTopic = true;
        return topic;
      } else {
        return t;
      }
    });
    if (!foundTopic) {
      this.state.topics.push(topic);
    }
  }
  setTopicId(topicid: number) {
    return this.fetchTopic(topicid);
  }
  getFetchedTopic(topicid: number) {
    if (this.state.topics.length > 0) {
      const topic = this.state.topics.find(t => t.id === topicid);
      if (topic) {
        return topic;
      }
    }
  }
  fetchTopic(topicid: number, forceFetch = false) {
    return new Promise((resolve, reject) => {
      // check if we already fetched the topic
      const topic = this.getFetchedTopic(topicid);
      if (!forceFetch && topic) {
        resolve(topic);
      }
      // console.log("fetching topic id " + topic?.id);
      // if not, fetch topic
      TopicRepository.getItem(topicid)
        .then((topic: any) => {
          if (topic) {
            if (this.state.projectid && topic.project.id !== this.state.projectid) {
              reject(null);
            }
            if (!this.state.projectid) {
              this.setProjectId(topic.project.id, false);
            }
            this.addToTopics(topic);
            resolve(topic);
          } else {
            console.log('error');
          }
        })
        .catch((error: any) => {
          reject(null);
          console.log(error);
        });
    });
  }
  private fetchTopics() {
    // console.log("fetching topics to projectid");
    TopicRepository.get({ projectid: this.state.projectid, fieldset: 'config' })
      .then((result: any) => {
        if (result.data) {
          this.setTopics(result.data);
        } else {
          console.log('error');
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  }
  getTopicsForThoughtCreate() {
    if (this.state.topics.length > 0) {
      return this.state.topics.filter(el => el.has_location !== 'required');
    }
    return [];
  }
  getTopics() {
    return this.state.topics;
  }

  fetchAllTopics(topicIds: number[]) {
    return new Promise((resolve, reject) => {
      let topic_obj_list: any = {};
      topicIds.forEach(id => {
        topic_obj_list[id] = this.getFetchedTopic(id);
      });

      const undefined_ids = topicIds.filter(id => topic_obj_list[id] == undefined);

      if (undefined_ids.length > 0) {
        TopicRepository.get({ id: undefined_ids, fieldset: 'config' })
          .then((resp: any) => {
            topic_obj_list = resp.data;
            resp.data.forEach((element: any) => {
              this.addToTopics(element);
            });
            resolve(topic_obj_list);
          })
          .catch((err: any) => reject(err));
      } else {
        resolve(Object.values(topic_obj_list));
      }
    });
  }

  setCurrentVoteStatus(status: IVoteStatus) {
    return (this.state.currentVoteStatus = status);
  }

  refetchCurrentVoteStatus(topicid: number) {
    // ODER ERRORS HIER
    return new Promise((resolve, reject) => {
      TopicRepository.getCurrentVoteStatus(topicid)
        .then((data: any) => {
          if (data) {
            this.state.currentVoteStatus = data;
          }
          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }
}
export const projectStore = new ProjectStore('PROJECT_STORE');
